import { formatCurrency, formatDateValue } from '@peanuds/shared';

import type { CardCurrency } from '../cards.types';

const DATE_TIME_LOCALE = 'en-US';

export const formatCardDateTime = (value: string) =>
  (
    formatDateValue(
      value,
      {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23',
        timeZone: 'UTC',
      },
      DATE_TIME_LOCALE,
    ) ?? ''
  ).replace(',', '');

export const formatCardDate = (value: string) =>
  formatDateValue(value, { year: 'numeric', month: '2-digit', day: '2-digit' }, DATE_TIME_LOCALE) ??
  '';

export const formatLongDate = (value: string) =>
  formatDateValue(value, { year: 'numeric', month: 'short', day: 'numeric' }, 'en-GB') ?? '';

export const formatWeekdayDate = (value: string) =>
  formatDateValue(
    value,
    { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC' },
    'en-GB',
  ) ?? '';

export const formatAmount = (amount: number, currency: CardCurrency = 'EUR') =>
  formatCurrency(amount, currency);

export const formatSignedAmount = (
  amount: number,
  direction: 'in' | 'out',
  currency: CardCurrency = 'EUR',
) => `${direction === 'in' ? '+' : '–'}${formatCurrency(amount, currency)}`;

export const formatCompactAmount = (amount: number) =>
  amount >= 1000 ? `${Math.round(amount / 1000)}k` : String(amount);
